module.exports = __webpack_public_path__ + "assets/img/2203.efc833b9.png";